import { createFileRoute, Outlet } from '@tanstack/react-router'

/** An asset's page and the asset labels sit under the Sites & assets register's crumb. */
export const Route = createFileRoute('/_app/service/assets')({
  staticData: { crumb: 'serviceSites' },
  component: Outlet,
})
